
import { sendFormData } from "../../services/file-upload.service";
import { uploadStatus } from "../../mixins/uploadStatus.js"
const state = {
    upload_currentStep: 0,
    upload_currentStepCompleted: true,
    upload_showFormErrors: false,
    upload_FormData: new FormData(),
    upload_allStepsCompleted: false,
    upload_lastStep: 4,
    upload_currentStatus: uploadStatus.INITIAL
};

const mutations = {
    nextStep(state) {
        if (state.upload_currentStep === state.upload_lastStep) {
            state.upload_currentStatus = uploadStatus.SAVING;

            sendFormData(state.upload_FormData)

                .then((x) => {
                    if (x.success) {
                        console.log('success')
                        state.upload_currentStatus = uploadStatus.SUCCESS;
                        state.upload_currentStep = 5;
                    } else {
                        console.log('error!', err.message)
                        state.upload_currentStatus = uploadStatus.FAILED;
                    }
                })
                .catch((err) => {
                    console.log('error!', err.response);
                    state.upload_currentStatus = uploadStatus.FAILED;
                });
        }

        else {
            state.upload_currentStep = state.upload_currentStep + 1;
        }

    },
    currentStepCompleted(state, value) {
        state.upload_currentStepCompleted = value;

        if (value === false) {
            state.upload_allStepsCompleted = false;
        }


    },
    showFormErrors(state, value) {
        state.upload_showFormErrors = value;
    },
    updateFormData(state, stepFormData) {
        for (var pair of stepFormData.entries()) {

            if (state.upload_FormData.has(pair[0])) {
                state.upload_FormData.delete(pair[0]);
            }
            state.upload_FormData.append(pair[0], pair[1]);
        }


        if (state.upload_currentStep == state.upload_lastStep) {
            state.upload_allStepsCompleted = true;
        }
    },
    resetForm(state, value) {
        state.upload_currentStep = 0;
        state.upload_currentStepCompleted = true;
        state.upload_showFormErrors = false;
        state.upload_FormData = new FormData();
        state.upload_allStepsCompleted = false;
        state.upload_submit_success = false;
        state.upload_currentStatus = uploadStatus.INITIAL;

    }
};

const getters = {
    upload_currentStep: state => state.upload_currentStep,
    upload_currentStepCompleted: state => state.upload_currentStepCompleted,
    upload_showFormErrors: state => state.upload_showFormErrors,
    upload_formData: state => state.upload_FormData,
    upload_allStepsCompleted: state => state.upload_allStepsCompleted,
    upload_lastStep: state => state.upload_lastStep,
    upload_currentStatus: state => state.upload_currentStatus,

};

const actions = {

    upload_goToNextStep({ commit, state }) {

        if (state.upload_currentStatus === uploadStatus.FAILED) {
            //bottone retry
            commit("nextStep", true)
        
        } else if (state.upload_currentStepCompleted === true) {
            //tutto completato vai avanti
            commit("nextStep", true)
            commit("currentStepCompleted", false);
            commit("showFormErrors", false);
        }
        else {
            // hai provato ad andare avanti ma mancavano dei field
            commit("showFormErrors", true);
        }

        // DEBUG ONLY --> fast forward steps
        // commit("nextStep", true)
        // commit("currentStepCompleted", false);
        // commit("showFormErrors", false);

    },

    upload_setCurrentStepCompleted({ commit }, value) {
        commit("currentStepCompleted", value)
  

    },
    upload_setShowFormErrors({ commit }, value) {
        commit("showFormErrors", value)

    },
    upload_storeStepData({ commit }, value) {
        commit("updateFormData", value)
    },
    upload_resetForm({ commit }, value) {

        commit("resetForm", value)
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
